export class SignalREvents{
    public static readonly BOOKINGSTATUSCHANGED = 'BOOKINGSTATUSCHANGED';
    public static readonly NEWBOOKING = 'NEWBOOKING'
    public static readonly CANCELCUSTOMERBOOKING = 'CANCELCUSTOMERBOOKING'
    public static readonly CANCELDRIVERBOOKING = 'CANCELDRIVERBOOKING'
    public static readonly RIDEBOOKED = 'RIDEBOOKED'
    /** #5: the driver's trip categories changed (vehicle, approval or an admin edit). */
    public static readonly CATEGORIESCHANGED = 'CATEGORIESCHANGED'
    /** #8: a fleet join request was sent, cancelled, accepted or declined. */
    public static readonly FLEETJOINREQUESTCHANGED = 'FLEETJOINREQUESTCHANGED'
    /** #34: the driver's background check status changed. */
    public static readonly BACKGROUNDCHECKCHANGED = 'BACKGROUNDCHECKCHANGED'
}